import React, { useEffect, useContext, useState } from 'react';
import PageWrapper from '../../../components/PageWrapper/PageWrapper';
import { CABA, CAPITAL, FORMULARIO_DOMICILIO_YSOCIAL, GEOLOCALIZACION_PAGE_YSOCIAL, GEOLOCALIZACION_YSOCIAL_STATE } from '../../../utils/constants';
import { IonCol, IonRow } from '@ionic/react';
import { Button, CardNota, InputText, ListAutocomplete, Modal, Separador, Subtitulo, TextArea, TextLink, Titulo } from 'app-principal-componentes-visuales';
import { Direccion } from '../../../interfaces/direccion.interface';
import { textIsValid } from '../../../utils/utils';
import { YsocialContext } from '../../../contexts/YsocialContext';
import { Provincia } from '../../../interfaces/provincia.interface';
import { Localidad } from '../../../interfaces/localidad.interface';
import {useDirecciones} from '../../../hooks/useDirecciones';
import Normalizacion from '../../../components/Modals/Normalizacion/Normalizacion';
import { inicioLocationWeb } from '../../../helpers/geolocalizacion';
import './FormularioDomicilioYsocial.scss';

const initialState_Direccion = { 
    barrio: '', calle: '', altura: '', piso: '', departamento: '', codigoPostal: '', 
    latitud: 0, longitud: 0, entreCalleUno: '', entreCalleDos: '', localidad: '', provincia: '', posicionExacta: false, observaciones: '', seleccionado: true
};

const FormularioDomicilioYsocial = ( {history} ) => {

    const { selectedDirection = null, isGeo, redirectTo } = history.location.state || {};
    const { ysocial, useRequest, isWeb, dispatchYsocial } = useContext(YsocialContext);
    const { apiRequest } = useRequest();
    const { usuario, provincias: provinciasContext } = ysocial;
    const [ direccion, setDireccion ] = useState<Direccion>(initialState_Direccion);
    const initialState_EditPlace = { edit: false, campo: ''};
    const [ editPlace, setEditPlace] = useState(initialState_EditPlace);
    const [ localidadConBarrios, setLocalidadConBarrios ] = useState(false);
    const [ newPlace, setNewPlace ] = useState(false);
    const [ provinciasEncontradas, setProvinciasEncontradas ] = useState([]);
    const [ provinciasInicializadas, setProvinciasInicializadas ] = useState([]);
    const [ localidadesEncontradas, setLocalidadesEncontradas ] = useState([]);
    const [ localidadesInicializadas, setlocalidadesInicializadas ] = useState([]);
    const [ barriosEncontrados, setBarriosEncontrados ] = useState([]);
    const [ barriosInicializados, setbarriosInicializados ] = useState([]);
    const [ provinciaSearch, setProvinciaSearch ] = useState('');
    const [ localidadSearch, setLocalidadSearch ] = useState('');
    const [ barrioSearch, setBarrioSearch ] = useState('');
    const [ requiereBarrio, setRequiereBarrio ] = useState(false);
    const [ provincias, setProvincias ] = useState<Provincia[]>();
    const [ localidades, setLocalidades ] = useState<Localidad[]>();
    const geolocalizacion = ysocial?.geolocalizacion;
    const { statusModulos } = ysocial;
    const { 
        addDirection, 
        modifyDirection, 
        handleNormalizacion, 
        edicionDireccion, 
        merlinWaiting,
        stateMerlin, 
        showNormalizacionModal, 
        setShowNormalizacionModal, 
        handleNormalizacionEditar, 
        handleCloseModalEdit, 
        handleCloseModal 
    } = useDirecciones({
        socioPrincipal: usuario, 
        apiRequest, 
        direccionesSocio: ysocial?.usuario?.direcciones, 
        isYsocial: true,
        isGeo,
        redirectTo
    });

    /** 
    * Inicializa la ubicacion de geolocalizacion
    */
    useEffect(() => {
        !geolocalizacion && inicioLocationWeb(dispatchYsocial);
    }, [])

    useEffect(() => {
        let nombresProvincias = provinciasContext.map(provincia => provincia.nombre);
        setProvincias(provinciasContext);
        setProvinciasInicializadas(nombresProvincias);
    }, [])

    useEffect(() => {
        if( selectedDirection && selectedDirection.calle ) {
            setNewPlace(false) 
            if(!(selectedDirection.provincia === 'BUENOS AIRES' && (selectedDirection.localidad === 'CIUDAD AUTONOMA BUENOS AIRES' || selectedDirection.localidad === 'CAPITAL FEDERAL'))) {
                setProvinciaSearch(selectedDirection.provincia === CAPITAL ? CABA : selectedDirection.provincia)
                setLocalidadSearch(selectedDirection.localidad)
                setBarrioSearch(selectedDirection.barrio)
                setDireccion(selectedDirection);
                selectedDirection.barrio !== '' ? setLocalidadConBarrios(true) : setLocalidadConBarrios(false);
            } else {
                let direccionErronea = {...selectedDirection, provincia:'', localidad:''}
                setDireccion(direccionErronea);
            }
        } else {
            setNewPlace(true)
        }
    }, [ selectedDirection ])
    

    useEffect(() => {
        if( provincias && direccion.provincia ) {
            direccion.provincia = direccion.provincia === CAPITAL ? CABA : direccion.provincia;
            let prov = provincias.find( prov => prov.nombre === direccion.provincia );
            setLocalidades(prov.localidades);
            let nombresLocalidades = prov.localidades.map( loc => loc.nombre);
            setlocalidadesInicializadas(nombresLocalidades);
        }

    }, [ direccion.provincia, provincias ])


    useEffect(() => {
        
        if( localidades && direccion.localidad ) {
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad.barrios.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setbarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
                setLocalidadConBarrios(false);
                setBarriosEncontrados([]);
            }
        }
        
    }, [ direccion.localidad, localidades ])

    useEffect(() => {
        if(!newPlace && direccion.localidad && localidades && barriosEncontrados.length === 0 ){
            let localidad = localidades.find( loc => loc.nombre === direccion.localidad );
            if ( localidad?.barrios.length > 0 ) {
                let nombresBarrios = localidad.barrios.map( loc => loc.nombre);
                setLocalidadConBarrios(true);
                setbarriosInicializados(nombresBarrios);
            } else {
                setDireccion({...direccion, barrio: ''});
            }
        }

    }, [newPlace, direccion.localidad])


    /**
     * Metodo que setea en el state el input de provincias al realizarse una modificacion y filtra las provincias mostradas en pantalla
     */
    const handleInputChangeProvince = ({target}) => {
        let {value} = target;
        if(provinciaSearch !== value) {
            if (value.length < 3) {
                setProvinciasEncontradas([]);
            } else { 
                let provinciasBuscadas = provinciasInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())});
                setProvinciasEncontradas(provinciasBuscadas);
            }
            setProvinciaSearch(value);
        }
    }

    /**
     * Metodo que setea en el state el input de la calle al realizarse una modificacion
     */
    const handleCalleChange = (calle) => {
        
        const noSpacesValue = calle.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(calle.target.value)

        if(isValid){
            setDireccion({...direccion, calle: noSpacesValue})
        } 
    }

    /**
     * Metodo que setea en el state el input de la altura al realizarse una modificacion
     */
    const handleAlturaChange = (altura) => {
        const isValid = textIsValid(altura.target.value)
        if(isValid){
            setDireccion({...direccion, altura:altura.target.value})
        } 
    }

    /**
     * Metodo que setea en el state el input del piso al realizarse una modificacion
     */
    const handlePisoChange = (piso) => {
        const noSpacesValue = piso.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(piso.target.value)
        if(isValid){
            setDireccion({...direccion, piso: noSpacesValue});
        } 
    }

    /**
     * Metodo que setea en el state el input del departamento al realizarse una modificacion
     */
    const handleDepartamentoChange = (departamento) => {
        const noSpacesValue = departamento.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(departamento.target.value)
        if(isValid){
            setDireccion({...direccion, departamento: noSpacesValue});
        } 
    }

    /**
     * Metodo que setea en el state el input de las observaciones al realizarse una modificacion
     */
    const handleObservacionesChange = (observaciones) => {
        const noSpacesValue = observaciones.target.value.replace(/^\s+/, '');
        const isValid = textIsValid(observaciones.target.value)
        if(isValid){
            setDireccion({...direccion, observaciones: noSpacesValue});
        } 
    }

    /**
     * Metodo encargado de ocultar el formulario para mostrar el modulo de searchbar para provincias, localidades, barrios
     * @param campo indica cual de los searchbars se va a renderizar
     */
    const handleEditPlace = (campo: string) => {
        setEditPlace({ edit:!editPlace.edit, campo:campo });
    }

    /**
     * Metodo que realiza el llamado a la modificacion o alta de una direccion
     */
    const handleSubmit = () => {
        if (direccion.provincia === CABA)
            direccion.provincia = CAPITAL
        if(newPlace || isGeo){
            addDirection(direccion)
        } else {
            modifyDirection(direccion)
        }
    }

    /**
     * Metodo que realiza la validacion del disable del boton guardar
     */
    const validPlace = () => {
        let valid: boolean;
        if(requiereBarrio && direccion.localidad !== '') {
            valid = (direccion.calle !== '' ? direccion.provincia === '' || direccion.localidad === '' || direccion.altura === '' || direccion.barrio === '' : true );
        } else {
            valid = (direccion.calle !== '' ? direccion.provincia === '' || direccion.localidad === '' || direccion.altura === '' : true )
        }
        return valid || direccion.observaciones?.length > 100;
    }

    /**
     * Metodo que cambia el estado de la direccion con la provincia que se selecciono del listado
     */
    const handleAcceptProvince = ( provinciaSeleccionada ) => {
        setProvinciaSearch(provinciaSeleccionada);
        setLocalidadesEncontradas([]);
        setLocalidadSearch("");
        setBarriosEncontrados([]);
        if(provinciaSeleccionada === CABA) {
            setLocalidadConBarrios(true)
            setRequiereBarrio(true)
            setDireccion({...direccion, provincia:provinciaSeleccionada, localidad:'CIUDAD AUTONOMA BUENOS AIRES', barrio:''});
        } else {
            setLocalidadConBarrios(false)
            setRequiereBarrio(false)
            setDireccion({...direccion, provincia:provinciaSeleccionada, localidad:'', barrio:''});
        }
        handleEditPlace('');
    }

    /**
     * Metodo que permite mostrar el formulario al cancelarse el ListAutocomplete
     */
    const handleCancel = (direccionCancel) => {
        if (direccionCancel === "provincia") {
            if(direccion.provincia !== '') {
                setProvinciaSearch(direccion.provincia);
            } else {
                setProvinciaSearch('')
                setProvinciasEncontradas([]);
            }
        }
        else if (direccionCancel === "localidad") {
            if(direccion.localidad !== '') {
                setLocalidadSearch(direccion.localidad);
            } else {
                setLocalidadesEncontradas([]);
                setLocalidadSearch('');
            }
        }
        else if (direccionCancel === "barrio") {
            if(direccion.barrio !== '') {
                setBarrioSearch(direccion.barrio);
            } else {
                setBarriosEncontrados([]);
                setBarrioSearch('');
            }
        }
        //editLocation();
        setEditPlace(initialState_EditPlace)
    }

    /**
     * Metodo que cambia el estado de la direccion con la localidad que se selecciono del listado
     */
    const handleAcceptLocalities = ( localidadSeleccionada ) => {
        setDireccion({...direccion, localidad:localidadSeleccionada, barrio:''});
        setLocalidadSearch(localidadSeleccionada);
        setBarrioSearch('');
        handleEditPlace('');
    }

    /**
     * Metodo que setea en el state el input de localidades al realizarse una modificacion y filtra las localidades mostradas en pantalla
     */
    const handleInputChangeLocalities = ({target}) => {
        let {value} = target;
        if(localidadSearch !== value) {
            if (value.length < 3) {
                setLocalidadesEncontradas([]);
            } else { 
                let localidadesBuscadas = localidadesInicializadas.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setLocalidadesEncontradas(localidadesBuscadas);
            }
            setLocalidadSearch(value);
        }
    }

    /**
    * Metodo que cambia el estado de la direccion con el barrio que se selecciono del listado
    */
    const handleAcceptNeighborhood = ( barrioSeleccionado ) => {
        setDireccion({...direccion, barrio:barrioSeleccionado});
        setBarrioSearch(barrioSeleccionado);
        handleEditPlace('');
    }

    /**
     * Metodo que setea en el state el input del barrio al realizarse una modificacion y filtra los barrios mostrados en pantalla
     */
    const handleInputChangeNeighborhood = ({target}) => {
        let {value} = target;
        if(barrioSearch !== target) {
            if (value.length < 3) {
                setBarriosEncontrados([]);
            } else { 
                let barriosBuscados = barriosInicializados.filter((item) => {return item.toUpperCase().includes(value.toUpperCase())})
                setBarriosEncontrados(barriosBuscados)
            }
            setBarrioSearch(value);
        }
    }

    const handleClickGeo = () => {
        history.push(GEOLOCALIZACION_PAGE_YSOCIAL, {redirectTo})
    }

    return (
        <PageWrapper 
            socio={usuario}
            pageClassName="formulariodomicilio-ysocial"
            path={FORMULARIO_DOMICILIO_YSOCIAL}
            notBack={false}
            tituloHeader='Datos de Ubicación'
            className={isWeb ? 'asistencia-formulario':'asistencia-formulario asistencia-formulario-mobile'}
            >
                <>
                {
                    !editPlace.edit ? 
                    <>   
                        <IonCol className='titulo'>
                            <Titulo 
                                className="titulo-asitencia-formulario-domicilio"
                                titulo={newPlace || isGeo ? 'Nuevo domicilio' : 'Editar domicilio'} 
                            />
                        </IonCol>
                        {
                            newPlace && !isGeo && !statusModulos?.deshabilitarGeolocalizacion &&
                            <IonRow>
                                <IonCol size='12' className='georeferencia__col'>
                                    <CardNota
                                        address
                                        disabled={!geolocalizacion}
                                        bgBlue
                                        id="card-nota"
                                        onClick={handleClickGeo}
                                        texto="Usar mi ubicación actual"
                                        />
                                </IonCol>
                            </IonRow> 
                        }
                        <IonRow>
                            {
                                newPlace &&
                                <IonRow>
                                    <IonCol size='12'>
                                        <Subtitulo
                                            titulo="Cargar datos manualmente"
                                            txt16
                                        />
                                    </IonCol>
                                </IonRow>
                            }
                            <IonCol size='12'>
                                <InputText
                                    id='formulario-input-calle'
                                    label='Calle'
                                    normalLink
                                    placeholder='Ingresá solo el nombre de la calle'
                                    type='text'
                                    value={direccion.calle} 
                                    onIonChange={handleCalleChange}
                                />
                            </IonCol>
                            <IonCol size='12' className='col--padding-top'>
                                <InputText
                                    id='formulario-input-numero'
                                    label='Número'
                                    normalLink
                                    placeholder='Ingresá la altura'
                                    type="number"
                                    inputmode="number"
                                    value={direccion.altura} 
                                    onIonChange={handleAlturaChange}
                                />
                            </IonCol>
                            <IonCol size='6' className='col--padding-right col--padding-top'>
                                <InputText
                                    id='formulario-input-piso'
                                    label='Piso'
                                    normalLink
                                    placeholder='Opcional'
                                    type='text'
                                    value={direccion.piso} 
                                    onIonChange={handlePisoChange}
                                />
                            </IonCol>
                            <IonCol size='6' className='col--padding-left col--padding-top'>
                                <InputText
                                    id='formulario-input-departamento'
                                    label='Departamento'
                                    normalLink
                                    placeholder='Opcional'
                                    type='text'
                                    value={direccion.departamento}
                                    onIonChange={handleDepartamentoChange}
                                />
                            </IonCol>
                        </IonRow>
                        <Separador />
                        <IonRow>
                            <IonCol size='12'>
                                <InputText
                                    id='formulario-input-provincia'
                                    elegirLink
                                    label='Provincia'
                                    onClick={() => handleEditPlace('provincia')}
                                    placeholder='Eleg&iacute; la provincia'
                                    type='text'
                                    value={direccion.provincia === CAPITAL ? CABA : direccion.provincia} 
                                />
                            </IonCol>
                            <IonCol size='12' className='col--padding-top'>
                                <InputText
                                    id='formulario-input-localidad'
                                    disable = { direccion.provincia === undefined || direccion.provincia === '' }
                                    elegirLink
                                    label='Localidad'
                                    onClick={() => handleEditPlace('localidad')}
                                    placeholder='Eleg&iacute; la localidad'
                                    type='text'
                                    value={direccion.localidad} 
                                />
                            </IonCol>
                            { localidadConBarrios && (
                                <IonCol size='12' className='col--padding-top'>
                                    <InputText
                                        id='formulario-input-barrio'
                                        disable = { direccion.localidad === undefined || direccion.localidad === ''}
                                        elegirLink
                                        label='Barrio'
                                        onClick={() => handleEditPlace('barrio')}
                                        placeholder='Eleg&iacute; el barrio'
                                        type='text'
                                        value={direccion.barrio} 
                                    />
                                </IonCol>
                            )}
                        </IonRow>
                        <Separador />
                        <IonRow>                               
                            <IonCol size='12'>
                                <Subtitulo titulo='¿Hay información adicional que quieras comentarnos?' id="subtitulo-info" />
                            </IonCol>
                            <IonCol size='12'>
                                <TextArea
                                    label='Información adicional'
                                    maxLength={100}
                                    onClick={function noRefCheck() { } }
                                    onIonChange={handleObservacionesChange}
                                    onIonInput={function noRefCheck() { } }
                                    placeholder='Ingresá tu manzana, country, lote, etc.'
                                    value={direccion.observaciones} 
                                    id="text-area-info-adicional"
                                />
                            </IonCol>
                            <IonCol size='12' className='guardar-cambios'>
                                <Button 
                                    id='formulario-domicilio-guardar'
                                    className='button--margin' 
                                    label = { newPlace ? 'Agregar':'Guardar cambios' } 
                                    onClick = { handleSubmit }
                                    primary 
                                    disable = { validPlace() }
                                    waiting = { Boolean(merlinWaiting) }
                                />
                            </IonCol>
                        </IonRow>
                    </>
                    :
                    <>
                        <IonRow>
                            <IonCol size='12' className='titulo'>
                                <Titulo titulo={'Nuevo domicilio'} />
                            </IonCol>
                        </IonRow>

                            { editPlace.campo === 'provincia' && (
                                <IonRow>
                                    <IonCol size='12'>
                                        <ListAutocomplete
                                            id='provincias-list'
                                            name='provinciaSearch'
                                            label='Provincia'
                                            placeholder='Eleg&iacute; la provincia'
                                            list={provinciasEncontradas}
                                            valueInputDefault={provinciaSearch}
                                            aceptarValor={handleAcceptProvince}
                                            onClickCancelar={()=> handleCancel("provincia")}
                                            onHandleInputChange={handleInputChangeProvince}
                                        />
                                    </IonCol>
                                </IonRow>
                            )}

                            { editPlace.campo === 'localidad' && (
                                <IonRow>
                                    <IonCol size='12'>
                                        <ListAutocomplete
                                            id='localidades-list'
                                            name='localidadSearch'
                                            label='localidad'
                                            placeholder='Eleg&iacute; la localidad'
                                            list={localidadesEncontradas}
                                            valueInputDefault={localidadSearch}
                                            aceptarValor={handleAcceptLocalities}
                                            onClickCancelar={() => handleCancel("localidad")}
                                            onHandleInputChange={handleInputChangeLocalities}
                                        />
                                    </IonCol>
                                </IonRow>
                            )}

                            { editPlace.campo === 'barrio' && (
                                <IonRow>
                                    <IonCol size='12'>
                                        <ListAutocomplete
                                            name='barrioSearch'
                                            label='Barrio'
                                            placeholder='Eleg&iacute; el barrio'
                                            list={barriosEncontrados}
                                            aceptarValor={handleAcceptNeighborhood}
                                            valueInputDefault={barrioSearch}
                                            id='barrio-list'
                                            onClickCancelar={() => handleCancel("barrio")}
                                            onHandleInputChange={handleInputChangeNeighborhood}
                                        />
                                    </IonCol>
                                </IonRow>
                            )}
                    </>
                }

                <Modal
					screen60
					hideCloseBtn
					//@ts-ignore
					className='modal_web'
					component={
						<Normalizacion
							onClick={edicionDireccion ? handleNormalizacionEditar : handleNormalizacion}
							closeModal={edicionDireccion ? handleCloseModalEdit : handleCloseModal}
							data={stateMerlin}
							isWeb={isWeb}
						/>
					}
					setShowModal={setShowNormalizacionModal}
					showModal={showNormalizacionModal}
					id="modal-normalizacion"
				/>
				{/* <Modal
					screen60
					hideCloseBtn
					//@ts-ignore
					component={
						<LocalidadError
							setLocalidadError={setLocalidadError}
							setEditarFormulario={setFormularioModal}
						/>
					}
					setShowModal={setLocalidadError}
					showModal={localidadError}
					id="modal-localidad-error"
				/> */}
                </>
        </PageWrapper>
    )
}

export default FormularioDomicilioYsocial;